const transferContent = {
  "1": {
    successMessage:
      "Kredi işleminiz başarıyla tamamlandı. Kredi tutarı bayi hesabına aktarıldı.",
    productListInfo:
      "Ödemenizde kullanabileceğiniz kredi seçeneklerini aşağıda görüntüleyebilirsiniz. Size en uygun kredi türü ve ödeme seçeneklerini seçiniz.",
    basketMessage: "üzerinden yapmak istediğiniz ödeme için yönlendirildiniz.",
    originalNetAmountLabel: "Bayiye Ödenecek Net Tutar",
  },
  "0": {
    successMessage:
      "Kredi işleminiz başarıyla tamamlandı. Kredi tutarı hesabınıza aktarıldı.",
    productListInfo:
      "Kullanabileceğiniz kredi seçeneklerini inceleyin. Size uygun kredi ve ödeme seçeneğini belirleyerek işleminize devam edin.",
    basketMessage:
      "üzerinden nakit kredi başvurunuz için yönlendirildiniz.",
    originalNetAmountLabel: "Hesabınıza Geçecek Net Tutar",
  },
};

export const getTransferContent = (doTransferToCompany) =>
  transferContent[doTransferToCompany] || transferContent["1"];